/*
  Comemoracao curta quando o carrinho cruza o minimo do frete gratis.
  Sem biblioteca externa: ~36 particulas animadas pela Web Animations API
  (mais confiavel que montar o shorthand `animation` com custom properties),
  removidas assim que a animacao termina.
  Silencioso quando o visitante pede menos movimento.
*/
window.cdv2Confetti = function (anchor) {
  if (!anchor) return;

  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {
    /* segue sem a checagem */
  }

  // Evita dois disparos sobrepostos no mesmo bloco.
  if (anchor.querySelector('.cdv2-confetti')) return;

  var host = document.createElement('div');
  host.className = 'cdv2-confetti';
  host.setAttribute('aria-hidden', 'true');

  var colors = ['#11B26A', '#0b8a52', '#E8A33D', '#A0CC29', '#1f1f1f'];
  var total = 36;
  var maxLife = 0;

  for (var i = 0; i < total; i++) {
    var piece = document.createElement('span');
    piece.className = 'cdv2-confetti__piece';
    piece.style.left = Math.random() * 100 + '%';
    piece.style.backgroundColor = colors[i % colors.length];
    if (i % 3 === 0) piece.style.borderRadius = '50%';
    host.appendChild(piece);

    var dx = (Math.random() * 180 - 90).toFixed(1);
    var dy = (70 + Math.random() * 90).toFixed(1);
    var rot = Math.floor(Math.random() * 720 - 360);
    var duration = 900 + Math.random() * 700;
    var delay = Math.random() * 200;
    maxLife = Math.max(maxLife, duration + delay);

    if (typeof piece.animate === 'function') {
      piece.animate(
        [
          { opacity: 1, transform: 'translate(0, 0) rotate(0deg) scale(1)' },
          { opacity: 1, offset: 0.7 },
          {
            opacity: 0,
            transform: 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + rot + 'deg) scale(0.6)',
          },
        ],
        {
          duration: duration,
          delay: delay,
          easing: 'cubic-bezier(0.19, 1, 0.22, 1)',
          fill: 'both',
        }
      );
    }
  }

  var position = window.getComputedStyle(anchor).position;
  if (position === 'static') anchor.style.position = 'relative';

  anchor.appendChild(host);
  setTimeout(function () {
    if (host.parentNode) host.parentNode.removeChild(host);
  }, maxLife + 300);
};
